import styled from 'styled-components';
import Button from 'components/ui/Button';

import { colours } from 'themes/default';

export const StyledButton = styled(Button)`
  height: 36px;
  width: 70%;
  margin-bottom: 9px;
`;

export const StyledUserSearchForm = styled('form')`
  background: ${colours.Greyscale.White};
  padding: 8px 16px 16px 16px;
  box-shadow: 0 0 30px ${colours.Greyscale.MistGrey};
  margin-bottom: 32px;
`;

export const StyledLabel = styled('label')`
  margin: 8px 0;
  font-size: 16px;
`;
